import React from 'react';
import { Box, ProfileInformationIcon } from '@common-fe/common-fe';

import { BlockWrapper } from '@/modules/ExpressSetup/ExpressSetupSignUp/components';

import Address from './Address';
import OrganizationProperties from './OrganizationProperties';

const BasicProperties = () => {
  return (
    <BlockWrapper Icon={ProfileInformationIcon} title="Basic Properties">
      <Box>
        <OrganizationProperties />
      </Box>
      <Box margin={{ top: 'spacing24' }}>
        <Address />  
      </Box>
    </BlockWrapper>
  );
};

export default BasicProperties;
